module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard animated slideInRight"
  }, [_c('h2', [_vm._v(_vm._s(_vm.items.activity.dashboard.title))]), _vm._v(" "), _c('div', {
    staticClass: "gauges left"
  }, [_c('div', {
    staticClass: "gauge"
  }, [_c('p', [_vm._v(_vm._s(_vm.dashValues[0]) + "%")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.items.activity.dashboard.gauges[0]))]), _vm._v(" "), _c('img', {
    style: ({
      transform: 'rotate(' + _vm.dashValues[0] * 2 + 'deg)'
    }),
    attrs: {
      "src": "media/page3/wand_mc.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gauge"
  }, [_c('p', [_vm._v(_vm._s(_vm.dashValues[1]) + "%")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.items.activity.dashboard.gauges[1]))]), _vm._v(" "), _c('img', {
    style: ({
      transform: 'rotate(' + _vm.dashValues[1] * 2 + 'deg)'
    }),
    attrs: {
      "src": "media/page3/wand_mc.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gauge"
  }, [_c('p', [_vm._v(_vm._s(_vm.dashValues[2]) + "%")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.items.activity.dashboard.gauges[2]))]), _vm._v(" "), _c('img', {
    style: ({
      transform: 'rotate(' + _vm.dashValues[2] * 2 + 'deg)'
    }),
    attrs: {
      "src": "media/page3/wand_mc.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "gauges right"
  }, [_c('div', {
    staticClass: "gauge"
  }, [_c('p', [_vm._v(_vm._s(_vm.dashValues[3]) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "bar-outer"
  }, [_c('div', {
    staticClass: "bar",
    style: ({
      height: _vm.dashValues[3] + '%'
    })
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.items.activity.dashboard.gauges[3]))])]), _vm._v(" "), _c('div', {
    staticClass: "gauge"
  }, [_c('p', [_vm._v(_vm._s(_vm.dashValues[4]) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "bar-outer"
  }, [_c('div', {
    staticClass: "bar",
    style: ({
      height: _vm.dashValues[4] + '%'
    })
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.items.activity.dashboard.gauges[4]))])]), _vm._v(" "), _c('div', {
    staticClass: "gauge"
  }, [_c('div', {
    staticClass: "stars-outer far"
  }, [_c('div', {
    staticClass: "stars-inner fas",
    style: ({
      width: _vm.dashValues[5] + '%'
    })
  })]), _vm._v(" "), _c('p', {
    staticClass: "percent"
  }, [_vm._v(_vm._s(_vm.dashValues[5]) + "%")]), _vm._v(" "), _c('p', {
    staticClass: "service"
  }, [_vm._v(_vm._s(_vm.items.activity.dashboard.gauges[5]))])]), _vm._v(" "), _c('div', {
    staticClass: "units"
  }, [_c('div', {
    staticClass: "holder"
  }, [_c('p', [_vm._v(_vm._s(_vm.items.activity.dashboard.inventory[0]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.units.hand))])]), _vm._v(" "), _c('div', {
    staticClass: "holder"
  }, [_c('p', [_vm._v(_vm._s(_vm.items.activity.dashboard.inventory[1]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.units.planned))])])])]), _vm._v(" "), _vm._t("warnings"), _vm._v(" "), _vm._t("terminal")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45196f85"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/section1/pages/components/Dashboard.vue
// module id = 139
// module chunks = 0